import { TpSlValueState } from '@ui/features/Trade/types';
import { SlValidationResult } from '@ui/features/Trade/utils/validateStoppLossPrice';
import { TpValidationResult } from '@ui/features/Trade/utils/validateTakeProfitPrice';
import BigNumber from 'bignumber.js';
import { useMemo } from 'react';

import { EditTpSlBaseline } from './getEditTpSlBaseline';

export const tpSlPriceValuesEqual = (current: string, original: string) => {
  if (current === '' && original === '') return true;
  if (current === '' || original === '') return false;

  const currentBn = new BigNumber(current);
  const originalBn = new BigNumber(original);

  if (!currentBn.isFinite() || !originalBn.isFinite()) {
    return current === original;
  }

  return currentBn.eq(originalBn);
};

export const getEditTpSlConfirmBtnDisabled = ({
  baseline,
  tp,
  sl,
  tpValidation,
  slValidation,
}: {
  baseline: EditTpSlBaseline;
  tp: TpSlValueState;
  sl: TpSlValueState;
  tpValidation: TpValidationResult | undefined;
  slValidation: SlValidationResult | undefined;
}) => {
  const tpChanged = !tpSlPriceValuesEqual(tp.priceValue, baseline.tp);
  const slChanged = !tpSlPriceValuesEqual(sl.priceValue, baseline.sl);
  const hasChanges = tpChanged || slChanged;

  return (
    !hasChanges ||
    tp.priceValue === '' ||
    (tpChanged && tpValidation?.valid === false) ||
    (slChanged && slValidation?.valid === false)
  );
};

export const useEditTpSlConfirmBtnDisabled = ({
  baseline,
  tp,
  sl,
  tpValidation,
  slValidation,
}: {
  baseline: EditTpSlBaseline | null;
  tp: TpSlValueState;
  sl: TpSlValueState;
  tpValidation: TpValidationResult | undefined;
  slValidation: SlValidationResult | undefined;
}) => {
  return useMemo(() => {
    if (!baseline) return true;

    return getEditTpSlConfirmBtnDisabled({
      baseline,
      tp,
      sl,
      tpValidation,
      slValidation,
    });
  }, [baseline, sl, slValidation, tp, tpValidation]);
};
